import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Question } from 'src/app/models/question.model';

@Component({
  selector: 'app-quiz-result',
  templateUrl: './quiz-result.component.html',
  styleUrls: ['./quiz-result.component.css']
})
export class QuizResultComponent implements OnInit {

  @Input() score: number = 0
  @Input() questions: Question[] = []
  gradeClassColor: string = ''
  gradeClassText: string = ''
  isShowResult: boolean = false
  constructor() { }

  @Output() onRetryCallback: EventEmitter<boolean> = new EventEmitter()
  @Output() onShuffleCallBack: EventEmitter<boolean> = new EventEmitter()

  ngOnInit(): void {
    this.gradeClassColor = this.getGradeColor();
  }

  getGradeColor(): string {
    var className = ''
    switch (true) {
      case this.score < 40:
        this.gradeClassText = 'Satisfactory'
        className = 'red'
        break;
      case this.score >= 40 && this.score < 50:
        className = 'light-red'
        this.gradeClassText = 'Satisfactory'
        break;
      case this.score >= 50 && this.score <= 60:
        className = 'orange'
        this.gradeClassText = 'Average'
        break;
      case this.score > 60 && this.score <= 70:
        className = 'light-orange'
        this.gradeClassText = 'Good'
        break;
      case this.score > 70 && this.score <= 80:
        className = 'yellow'
        this.gradeClassText = 'Very Good'
        break;
      case this.score > 80 && this.score <= 90:
        className = 'light-green'
        this.gradeClassText = 'Excellent'
        break;
      default:
        className = 'green'
        this.gradeClassText = 'Outstanding'
        break;
    }
    return className
  }

  ngOnChanges(changes: SimpleChanges) {
    this.gradeClassColor = this.getGradeColor()
  }

  onRetry() {
    this.onRetryCallback.emit();
  }

  onSuffleQuestions() {
    this.onShuffleCallBack.emit();
  }

  onShowResult() {
    this.isShowResult = !this.isShowResult
  }

  getIndex(i) {
    return i + 1
  }

 





}
